import { MoneyOutlined } from "@mui/icons-material";
import { List, MenuItem, Tooltip, Typography } from "@mui/material";
import { skipToken } from "@reduxjs/toolkit/query";
import { useGetPatientCouponsQuery } from "src/api/services/patientsApi";

const CouponsCell = ({
  invoiceId,
  patientId,
}: {
  invoiceId: string | null;
  patientId: number;
}) => {
  const { data = [] } = useGetPatientCouponsQuery(
    invoiceId
      ? { id: patientId, params: { invoice_id: invoiceId, redeemed: true } }
      : skipToken,
  );

  const invoiceCoupons = (
    <List>
      {data.length === 0 ? (
        <Typography>No coupons</Typography>
      ) : (
        data.map((c) => (
          <MenuItem
            key={c.id}
          >{`${c.coupon.name}: $${c.coupon.amount} off`}</MenuItem>
        ))
      )}
    </List>
  );

  return (
    <Tooltip title={invoiceCoupons}>
      <MoneyOutlined />
    </Tooltip>
  );
};

export default CouponsCell;
